import { useIdentity } from '@interhyp/platform-auth';

import { COMPANY_ID_INTERHYP } from '../constants/companies';

export function useIsBroker(): boolean {
  const identity = useIdentity();

  return identity?.userType === 'PROFESSIONAL' && identity?.companyId !== COMPANY_ID_INTERHYP;
}
